import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useI18n } from "../i18n/I18nContext";

export function LanguageSwitcher({ light = false }) {
  const { lang } = useParams();
  const { setLang } = useI18n();
  const location = useLocation();
  const navigate = useNavigate();

  const switchTo = (target) => {
    if (target === lang) return;
    setLang(target);
    const rest = location.pathname.replace(/^\/(ar|en)/, "");
    navigate(`/${target}${rest}${location.hash || ""}`);
  };

  const base =
    "px-2.5 py-1 text-xs font-mono uppercase tracking-widest rounded-md transition-colors duration-200";
  const activeCls = light ? "bg-white text-ink" : "bg-ink text-white";
  const idleCls = light
    ? "text-white/70 hover:text-white"
    : "text-mineral hover:text-ink";

  return (
    <div
      data-testid="language-switcher"
      className={`inline-flex items-center gap-1 rounded-lg p-0.5 ${
        light ? "bg-white/10" : "bg-ink/5"
      }`}
    >
      <button
        type="button"
        data-testid="lang-switch-ar"
        aria-pressed={lang === "ar"}
        onClick={() => switchTo("ar")}
        className={`${base} ${lang === "ar" ? activeCls : idleCls}`}
      >
        ES
      </button>
      <button
        type="button"
        data-testid="lang-switch-en"
        aria-pressed={lang === "en"}
        onClick={() => switchTo("en")}
        className={`${base} ${lang === "en" ? activeCls : idleCls}`}
      >
        EN
      </button>
    </div>
  );
}
